import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getLeaderboardSlideSnapshot: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboards/slide/snapshot`,
  },
  getLeaderboardSlideTopN: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboards/slide/topn`,
  },
  getLeaderboardSlideAround: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/leaderboards/slide/around`,
  },
  getScore: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/scores`,
  },
  getStats: {
    method: 'GET',
    url: `${configs.kvSyncApiUrl}/api/aha-sync/answers/stats`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getAggregation = (subject, teamScoringRule) => {
  if (subject === 'team') {
    if (teamScoringRule === 'average') {
      return 'average_score'
    }
    if (teamScoringRule === 'fastest') {
      return 'first_score'
    }
  }
  return 'total_score'
}

const toLeaderboardBody = (res, subject) => {
  const items = res?.items || []
  if (subject === 'team') {
    return {
      teams: items.map((item) => ({
        id: item.id,
        name: item.name,
        totalPoint: item.score,
        index: item.rank,
        members: item.members || [],
      })),
    }
  }
  return {
    audiences: items.map((item) => ({
      audience: item.id,
      audienceName: item.name,
      audienceEmoji: item.emoji,
      teamId: item.teamId,
      totalPoint: item.score,
      index: item.rank,
    })),
  }
}

const getLeaderboardSlideSnapshot = async ({
  key,
  t,
  subject,
}) => {
  const res = await resource.getLeaderboardSlideSnapshot({ key, t })
  return toLeaderboardBody(res.body, subject)
}

// Self-paced: the live top-N DB read (not a snapshot); merged with the around-window in the store.
const getLeaderboardSlideTopN = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  slideIds,
  n,
}) => {
  const res = await resource.getLeaderboardSlideTopN({
    presentationId,
    presentationVersion,
    subject,
    aggregation: getAggregation(subject, teamScoringRule),
    slideIds: JSON.stringify(slideIds),
    n,
  })
  return toLeaderboardBody(res.body, subject)
}

// The audience's own rank-neighbourhood (k rows centred on subjectId), so their row survives the topn cap.
const getLeaderboardSlideAround = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  slideIds,
  subjectId,
  k,
}) => {
  const res = await resource.getLeaderboardSlideAround({
    presentationId,
    presentationVersion,
    subject,
    aggregation: getAggregation(subject, teamScoringRule),
    slideIds: JSON.stringify(slideIds),
    subjectId,
    k,
  })
  return toLeaderboardBody(res.body, subject)
}

const getScore = async ({
  presentationId,
  presentationVersion,
  subject,
  subjectId,
  slideIds,
  aggregation,
  teamScoringRule,
}) => {
  const res = await resource.getScore({
    presentationId,
    presentationVersion,
    subject,
    subjectId,
    slideIds: JSON.stringify(slideIds),
    aggregation: aggregation || getAggregation(subject, teamScoringRule),
  })
  return res.body
}

const getStats = async ({
  presentationId,
  presentationVersion,
  subject,
  subjectId,
  slideIds,
}) => {
  const res = await resource.getStats({
    presentationId,
    presentationVersion,
    subject,
    subjectId,
    slideIds: JSON.stringify(slideIds),
  })
  return res.body
}

export default {
  initResource,
  getLeaderboardSlideSnapshot,
  getLeaderboardSlideTopN,
  getLeaderboardSlideAround,
  getScore,
  getStats,
}
